import PreviewImages from '@/common/components/adjusterReport/previewImages/PreviewImages';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import RepeatCapturingModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/RepeatCapturingModal';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import { useRemoveDamagedPartsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/removeDamagedParts/removeDamagedPartsQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default function VehicleCulpritServerImagePreviewPage() {
  return (
    <MainLayout title="مقصر / تصاویر" header="titleHeader">
      <VehicleCulpritServerImagePreview />
    </MainLayout>
  );
}

const VehicleCulpritServerImagePreview = () => {
  const { id, culpritId } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { closeModal, open, openModal } = useModal();
  const { resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();
  const { getCurrentFileOfflineImages, deleteOfflineFileData } =
    useGetOfflineImages();
  const { data: vehicleImages } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
      damaged_id: +culpritId!,
      participantRoleType: 'culprit',
    }),
  );
  const addDamagedPoints = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).ADJUSTER_VEHICLE.previewImageDamagePoint,
    );
  };
  const retakePhotoModal = () => {
    openModal();
  };
  const confirmRetakePhoto = async () => {
    const file = await getCurrentFileOfflineImages({});
    if (file.hasOffline && file.offlineItem?.id) {
      deleteOfflineFileData(file.offlineItem?.id);
    }
    openModal();
    resetDamagedPoints();
    resetCameraStore();
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).ADJUSTER_VEHICLE.damagedPoints,
    );
  };

  const { mutateAsync: deleteImage } = useRemoveDamagedPartsQueryOptions();

  const handleDeleteDamagePointImage = (
    image_id: number,
    closeConfirmationModal?: () => void,
  ) => {
    deleteImage({
      image_id,
      id: +id!,
      type: 'damaged',
      participantRoleType: 'culprit',
    }).then(() => {
      closeConfirmationModal?.();
      queryClient.invalidateQueries({
        queryKey: getDamagedAdjusterImagesQueryOptions({
          id: +id!,
          enable: true,
          damaged_id: +culpritId!,
          participantRoleType: 'culprit',
        }).queryKey,
      });
    });
  };

  return (
    <Box pt={24}>
      <PreviewImages
        userType="culprit"
        addDamagePoint={addDamagedPoints}
        handleDeleteImage={handleDeleteDamagePointImage}
        images={{
          damagedImages:
            vehicleImages?.damaged_parts.map((item) => ({
              name: item.label,
              src: item.url,
              id: item.id,
              type: 'damaged',
            })) ?? [],
          vehicleImages:
            vehicleImages?.vehicle.map((item) => ({
              name: item.label,
              src: item.url,
            })) ?? [],
        }}
        retakeImage={retakePhotoModal}
      />
      <RepeatCapturingModal
        closeModal={closeModal}
        repeatCapturing={confirmRetakePhoto}
        open={open}
      />
    </Box>
  );
};
